// extracted by mini-css-extract-plugin
export default {"solid":"divider_solid__hC7di"};